<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>회사 상세 정보 조회</h2>
      </div>
      <div class="table-btn center-right">
        <div>
          <button class="btn btn-140" @click="goList">회사 리스트</button>
        </div>
        <div>
          <button class="btn btn-140" @click="deleteCompany">
            <span v-if="!processing" class="process">회사 삭제</span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
        <div>
          <button class="btn btn-140" @click="updateCompany">회사 수정</button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <div v-if="detailType === 'view'" class="table-content">
        <table>
          <tr>
            <td class="header">회사 ID</td>
            <!-- TODO <td>{{ company.companyAlias }}</td> -->
            <td>{{ company.companyID }}</td>
          </tr>
          <tr>
            <td class="header">사업자 번호</td>
            <td>{{ company.registrationNo }}</td>
          </tr>
          <tr>
            <td class="header">모회사 ID</td>
            <!-- TODO <td>{{ company.parentCompanyAlias }}</td> -->
            <td>{{ company.parentCompanyID }}</td>
          </tr>
          <tr>
            <td class="header">모회사 역할</td>
            <td>{{ $getConstName('companyScope', company.parentCompanyScope) }}</td>
          </tr>
          <tr>
            <td class="header">담당자 이름</td>
            <td>{{ company.representativeName }}</td>
          </tr>
          <tr>
            <td class="header">담당자 전화번호</td>
            <td>{{ company.representativeMobile }}</td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">회사 이름</td>
            <td>{{ company.companyName }}</td>
          </tr>
          <tr>
            <td class="header">역할</td>
            <td>{{ $getConstName('companyScope', company.scope) }}</td>
          </tr>
          <tr>
            <td class="header">모회사 이름</td>
            <td>{{ company.parentCompanyName }}</td>
          </tr>
          <tr>
            <td class="header">담당자 ID</td>
            <td>{{ company.representativeUserID }}</td>
          </tr>
          <tr>
            <td class="header">담당자 이메일</td>
            <td>{{ company.representativeEmail }}</td>
          </tr>
          <tr>
            <td class="header"></td>
            <td></td>
          </tr>
        </table>
      </div>
      <div v-if="detailType === 'edit'" class="table-content">
        <table>
          <tr>
            <td class="header">회사 ID</td>
            <!-- TODO <td><input type="text" v-model="editCompany.companyAlias" /></td> -->
            <td> {{ editCompany.companyID }} </td>
          </tr>
          <tr>
            <td class="header">사업자 번호</td>
            <td><input type="text" v-model="editCompany.registrationNo" /></td>
          </tr>
          <tr>
            <td class="header">모회사</td>
            <td>
              <div v-if="editCompany.scope && editCompany.scope > 2">
                <select v-model="editCompany.parentCompanyID">
                  <option v-for="item in parentCompanyList" :key="item.companyID" :value="item.companyID">
                    {{ item.companyName }}
                  </option>
                </select>
              </div>
              <div v-else>-</div>
            </td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">회사 이름</td>
            <td><input type="text" v-model="editCompany.companyName" /></td>
          </tr>
          <tr>
            <td class="header">역할</td>
            <td>
              <select v-model="editCompany.scope" @change="changeScope(editCompany.scope)">
                <option v-for="item in companyScope" :key="item.code" :value="item.code">
                  {{ item.name }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="header">담당자 이름</td>
            <td>
              <select v-model="editCompany.representativeUID">
                <option v-for="item in userList" :key="item.uID" :value="item.uID">
                  {{ item.name }}
                </option>
              </select>
            </td>
          </tr>
        </table>
      </div>
      <div v-if="detailType === 'edit'" class="table-btn center">
        <button
          class="btn btn-140 btn-blue-line" @click="excuteUpdate">
          <span v-if="!processing" class="process">수정</span>
          <ButtonLoading v-else></ButtonLoading>
        </button>
        <button
          class="btn btn-right"
          @click="cancelUpdate"
        >취소</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-continue */

import Configuration from '@/js/Configuration';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  props: [
    'company',
  ],
  components: {
    ButtonLoading,
  },
  data: () => ({
    detailType: 'view',
    editCompany: null,
    companyScope: [],
    parentCompanyList: [],
    userList: [],
    processing: false,
  }),
  created() {
    const token = this.$jwtDecode(this.$cookie.get('accessToken'));
    this.scope = token.scope;
    this.role = token.role;

    for (let i = 1; i < this.$companyScope.length; i++) {
      if (i > 1) {
        this.companyScope.push(this.$companyScope[i]);
      } else if (i === 1 && (
        (this.scope === 1 && this.role === 1) ||
        (this.scope === 2 && this.role === 1)
      )) {
        this.companyScope.push(this.$companyScope[i]);
      }
    }
  },
  watch: {
    detailType() {
      if (this.detailType === 'edit') {
        this.changeScope(this.company.scope);
      }
    },
  },
  methods: {
    async changeScope(scope) {
      this.parentCompanyList = [];

      try {
        const url = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/list?page=1&limit=500`;

        const list = await this.$http.get(url, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (list.status !== 200) {
          if (list.status === 204) {
            return;
          }
        }

        const companyList = [];
        for (let i = 0; i < list.data.companies.length; i++) {
          const p = list.data.companies[i];

          if (p.companyID === this.company.companyID) continue;

          if (p.scope === scope - 1) {
            companyList.push(p);
          }
        }

        this.parentCompanyList = companyList;
      } catch (e) {
        this.parentCompanyList = [];
        console.error(e);
      }
    },
    async updateCompany() {
      this.userList = [];
      this.userList.push('');
      const userList = await this.$listCompanyUser(this.company.companyID);
      if (userList) {
        for (let i = 0; i < userList.length; i++) {
          this.userList.push(userList[i]);
        }
      }

      this.editCompany = JSON.parse(JSON.stringify(this.company));
      this.detailType = 'edit';
    },
    async excuteUpdate() {
      try {
        this.processing = true;
        const url = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/${this.company.companyID}`;

        const param = this.editCompany;
        const createResult = await this.$http.put(url,
          param,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        this.processing = false;

        this.$emit('refreshList', null, 'all', 1);
      } catch (e) {
        this.processing = false;
        console.error(e);
      }
    },
    cancelUpdate() {
      this.detailType = 'view';
    },
    async deleteCompany() {
      this.processing = true;
      const company = await this.$getCompany(this.company.companyID, true, true);
      if (!company) {
        alert('존재하지 않는 회사입니다.');
        this.processing = false;
        return;
      } else if (company.divisions && company.divisions.length > 0) {
        alert('부서가 있는 회사는 삭제할 수 없습니다.\n"계정 관리"를 확인해 주세요.');
        this.processing = false;
        return;
      } else if (company.devices && company.devices.length > 0) {
        let d = '';
        if (company.devices) {
          for (let i = 0; i < company.devices.length; i++) {
            if (i !== 0) {
              d += ', ';
            }
            d += company.devices[i].deviceName;
          }
        }
        alert(`냉장고를 관리하는 회사는 삭제할 수 없습니다.\n"냉장고 관리"를 확인해 주세요.\n냉장고: ${d}`);
        this.processing = false;
        return;
      }

      if (!confirm('정말 삭제하시겠습니까?')) {
        this.processing = false;
        return;
      }

      try {
        const url = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/${this.company.companyID}`;

        const createResult = await this.$http.delete(url,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        this.processing = false;
        this.$emit('refreshList', null, 'all', 1);
      } catch (e) {
        if (e.response.status === 403) {
          alert('사용중 입니다.');
        } else {
          console.error(e);
        }
        this.processing = false;
      }
    },
    goList() {
      this.$emit('refreshList', null, 'all');
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/company/CompanyDetail.vue